<li>
  <span
    #item
    tabindex="0"
    class="dropdown-item"
    [ngClass]="{
      'dropdown-item-selectable': !clickedItem?.isNotSelectable,
      'dropdown-item-blue': clickedItem?.setItemTextColorToBlue
    }"
    (click)="click()"
    (keydown)="keydown($event, clickedItem)"
  >
    <ng-content></ng-content>
  </span>
</li>
